export const APP_ERRORS = {
  LOGIN_EXPIRED: 'Your session has expired. Please login again!',
  UNEXPECTED_RESPONSE_CODE: 'Error while fetching data. Please try again!',
}
